import { NgModule } from '@angular/core';
import { DialogFacilityComponent } from './dialog-facility/dialog-facility.component';
import { DialogOverviewConfirmationComponent } from './dialog-overview-confirmation/dialog-overview-confirmation.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';
import { SiteSwitcherComponent } from './site-switcher/site-switcher.component';
import { ChangePasswordComponent } from './profile-details/change-password/change-password.component';
import { DeleteAccountComponent } from './profile-details/delete-account/delete-account.component';
import { PrivacyPolicyComponent } from './profile-details/privacy-policy/privacy-policy.component';
import { ServiceAgreementComponent } from './profile-details/service-agreement/service-agreement.component';
import { SettingsComponent } from './profile-details/settings/settings.component';
import { SubscriptionComponent } from './profile-details/subscription/subscription.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpClientModule } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Ng9PasswordStrengthBarModule } from 'ng9-password-strength-bar';
import { RouterModule } from '@angular/router';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { Ng2TelInputModule } from 'ng2-tel-input';

@NgModule({
  declarations: [
    DialogFacilityComponent,
    DialogOverviewConfirmationComponent,
    MyProfileComponent,
    ProfileDetailsComponent,
    SiteSwitcherComponent,
    ChangePasswordComponent,
    DeleteAccountComponent,
    PrivacyPolicyComponent,
    ServiceAgreementComponent,
    SettingsComponent,
    SubscriptionComponent,
  ],
  imports: [
    Ng2SearchPipeModule, MatProgressBarModule, MatChipsModule, MatRadioModule, Ng9PasswordStrengthBarModule, MatButtonToggleModule, MatPaginatorModule,
    MatTabsModule, MatSelectModule, MatCheckboxModule, MatDialogModule, MatCardModule, MatTableModule,
    BrowserAnimationsModule, MatInputModule, MatIconModule, BrowserModule, MatButtonModule, MatDividerModule, MatSlideToggleModule,
    FormsModule, TranslateModule, MatSortModule, MatAutocompleteModule, MatTooltipModule,
    ReactiveFormsModule, HttpClientModule,/*DhhpButtonModule,*/RouterModule, PopoverModule.forRoot(), Ng2TelInputModule
  ],
  entryComponents: [DialogOverviewConfirmationComponent, DialogFacilityComponent, SiteSwitcherComponent, ServiceAgreementComponent],
  exports: [
    MyProfileComponent, ProfileDetailsComponent
  ]
})
export class ProfileModule { }
